export default "__VITE_ASSET__DVaqjAsU__"